// extracted by mini-css-extract-plugin
module.exports = {"DoubleBorderScreenSkin":"_3TBug","doubleBorderScreenSkin":"_3TBug","bg":"_2zdfw","doubleBorderContainer":"I806x"};